import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Status',
      fields: {
        room_service_visible: {
          label: 'Kamer-/tafelservice zichtbaar',
        },
        has_room_service: {
          label: 'Kamer-/tafelservice',
        },
      },
    },
    settings: {
      title: 'Instellingen',
      table_number: {
        label: 'Tafelnummer weergeven',
      },
    },
    locations: {
      title: 'Locaties',
    },
  },
  form: {
    google_place: {
      label: 'Naam',
      placeholder: 'Naam op Google Maps',
    },
    type: {
      label: 'Type',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Kamerservice',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Tafelservice',
      },
    },
    name: {
      label: 'Locatienaam',
      placeholder: 'Voer een locatienaam in die duidelijk is voor de klant',
    },
    street_name: {
      label: 'Straat',
      placeholder: 'Straatnaam',
    },
    street_number: {
      label: 'Huisnummer',
      placeholder: 'Huisnummer',
    },
    city: {
      label: 'Stad',
      placeholder: 'Stad',
    },
    zip_code: {
      label: 'Postcode',
      placeholder: 'Postcode',
    },
  },
  fields: {
    id: 'id',
    type: 'Type',
    name: 'Naam',
    address: 'Adres',
    is_active: 'Actief',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Kamerservice',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Tafelservice',
  },
  modals: {
    delete_location: {
      title: 'Weet u het zeker?',
      description: 'Dit verwijdert de locatie „{{name}}"',
    },
  },
  buttons: {
    save: 'Opslaan',
    delete: 'Verwijderen',
  },
  toasts: {
    failed_to_load_locations: 'Laden van locaties mislukt, herlaad de pagina',
    failed_to_create_location: 'Aanmaken van locatie mislukt',
    failed_to_toggle_location: 'Wijzigen van locatiebeschikbaarheid mislukt',
    failed_to_delete_location: 'Verwijderen van locatie mislukt',
    location_got_created: 'Locatie succesvol aangemaakt',
    location_got_deleted: 'Locatie is verwijderd',
    saving_success: 'Succesvol opgeslagen',
    saving_error: 'Opslaan mislukt',
  },
};
